import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createUrl } from '../utils/url';
import LinkButton from './LinkButton';

const mapStateToProps = ({
  session,
  location: { baseURL }
}) => ({
  isAuthenticated: session.isAuthenticated,
  baseURL
});

const SignUpButton = ({
  isAuthenticated, baseURL, location, children, ...props
}) => {
  const signUpPath = `/join/?routeTo=${createUrl(baseURL, location)}`;
  return !isAuthenticated
    ? <LinkButton to={signUpPath} external {...props}>{children}</LinkButton>
    : null;
};

export default connect(mapStateToProps, null)(withRouter(SignUpButton));



// WEBPACK FOOTER //
// ./src/universal/ui/components/SignUpButton.js